import React from "react";
import careem_wink_green from "../../images/careem_wink_green.svg";
import { withTranslation } from "react-i18next";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";

class CorporateSignupError extends React.Component {
  componentDidMount() {
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_VIEW_ERROR, {
      page_name: "corporate_signup_error",
    });
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <img src={careem_wink_green} alt="Careem Logo" className="signed-in-logo" />
        <h1> {t("signup:corporate_error_signup")}</h1>

      </div>
    );
  }
}
export default withTranslation()(CorporateSignupError);
